import DataMap from '../classes/data-map';

/**
 * Class representing the HousingActivity Map.
 */
export default class HousingAffordabilityMap {
    DataPageInstance;
    DataMapInstance;

    /**
     * Create a HousingAffordabilityMap instance.
     * @param {Object} DataPageInstance - The instance of the Data Page.
     */
    constructor(DataPageInstance) {
        this.DataPageInstance = DataPageInstance;

        this.DataMapInstance = new DataMap('.mapbox');
    }

    /**
     * Set map data on the map instance.
     * @param {Object|string} mapData - The map data to be set on the map.
     * @example
     * // Set map data
     * setMap(mapData);
     */
    setMap(mapData) {
        if (!mapData) {
            return;
        }
        const requestData = this.DataPageInstance.getGeoRequestParams();
        let mapArray = '';
        try {
            mapArray = JSON.parse(mapData);
        } catch {
            return;
        }

        this.DataMapInstance.selectArea(
            mapArray,
            requestData.geoId,
            requestData.geoType,
        );
    }

    resize() {
        this.DataMapInstance.resize();
    }
}
